import React from 'react';

import { ListingsSearchCategory } from '@kamernet/core/Routing/routes/ListingsSearch';

import { ContentCountryAntisquat } from './ContentCountryAntisquat';
import { ContentCountryApartment } from './ContentCountryApartment';
import { ContentCountryFurnishedApartments } from './ContentCountryFurnishedApartments';
import { ContentCountryGeneric } from './ContentCountryGeneric';
import { ContentCountryLongTermRentals } from './ContentCountryLongTermRentals';
import { ContentCountryRoom } from './ContentCountryRoom';
import { ContentCountryShortTermRentals } from './ContentCountryShortTermRentals';
import { ContentCountryStudentHousing } from './ContentCountryStudentHousing';
import { ContentCountryStudio } from './ContentCountryStudio';

export interface ContentCountryProps {
  mainSearchCategory: ListingsSearchCategory;
}

export const ContentCountry = ({ mainSearchCategory }: ContentCountryProps) => {
  switch (mainSearchCategory) {
    case ListingsSearchCategory.Generic:
      return <ContentCountryGeneric />;
    case ListingsSearchCategory.Room:
      return <ContentCountryRoom />;
    case ListingsSearchCategory.Apartment:
      return <ContentCountryApartment />;
    case ListingsSearchCategory.Studio:
      return <ContentCountryStudio />;
    case ListingsSearchCategory.Antisquat:
      return <ContentCountryAntisquat />;
    case ListingsSearchCategory.StudentHousing:
      return <ContentCountryStudentHousing />;
    case ListingsSearchCategory.FurnishedApartment:
      return <ContentCountryFurnishedApartments />;
    case ListingsSearchCategory.ShortTermRental:
      return <ContentCountryShortTermRentals />;
    case ListingsSearchCategory.LongTermRental:
      return <ContentCountryLongTermRentals />;
    default:
      return null;
  }
};
